module.exports = __webpack_public_path__ + "img/super05.ed4f1341.png";